import { cn } from "@/lib/utils";
import type { TikTokSampleSuggestion } from "@/services/tiktokShop.service";

/** The review policy's call on a request, with its first reason; all reasons on hover. */
export function SuggestionChip({ suggestion }: { suggestion: TikTokSampleSuggestion | null }) {
  if (!suggestion) return null;
  const tone = {
    APPROVE: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
    REJECT: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
    REVIEW: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  }[suggestion.decision];
  const label = { APPROVE: "Suggest approve", REJECT: "Suggest reject", REVIEW: "Needs a look" }[suggestion.decision];
  return (
    <span className="flex min-w-0 flex-col gap-0.5">
      <span className={cn("w-fit whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium", tone)} title={suggestion.reasons.join("\n")}>
        {label}
      </span>
      <span className="truncate text-[11px] text-muted-foreground" title={suggestion.reasons.join("\n")}>
        {suggestion.reasons[0]}
      </span>
    </span>
  );
}
